import { useState } from 'react';
import { MapPin, Pencil, Search } from 'lucide-react';
import ModalShell from '../ui/ModalShell';
import { SECTION_COLOR, CERVENA, posli, tlumene, cara, Pole, Tlacitko, PatickaModalu } from './ui';

/**
 * Provozovna → Adresa a poloha. Adresa bistra a GPS (BISTROADRESA,
 * BISTROLAT/LNG) — z nich počítá Rozvoz ETA návratu rozvozce a dojezdy.
 * Úprava v `ModalShell`: adresa → „Najít" (Mapy.cz) → náhled → Uložit.
 *
 * Dřív v Nastavení → Provozní náklady nad tabulkou nákladů.
 */
export default function ProvozovnaAdresa({ lokace, onZmena, upravuje, isDark, isMobile, inputStyle }) {
    const [uprava, setUprava] = useState(false);
    const ml = tlumene(isDark);
    return (
        <div>
            <div className="flex items-start" style={{ gap: 12 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <Pole popisek="Adresa" isDark={isDark}>{lokace?.adresa || null}</Pole>
                    <Pole popisek="GPS" isDark={isDark}>
                        {lokace?.lat != null ? `${Number(lokace.lat).toFixed(6)}, ${Number(lokace.lng).toFixed(6)}` : <span style={{ color: CERVENA }}>nevyplněno</span>}
                    </Pole>
                </div>
                {upravuje && !isMobile && <Tlacitko isDark={isDark} Icon={Pencil} onClick={() => setUprava(true)}>Upravit</Tlacitko>}
            </div>
            {lokace?.static_map_url && (
                <img src={lokace.static_map_url} alt="Poloha bistra na mapě" className="rounded-lg"
                    style={{ width: '100%', maxWidth: 520, marginTop: 8, border: `1px solid ${cara(isDark)}` }} />
            )}
            <p className="text-xs" style={{ color: ml, marginTop: 10 }}>Z polohy počítá Rozvoz dojezdy a návrat rozvozce do KDS.</p>
            {uprava && (
                <UpravaAdresy lokace={lokace} isDark={isDark} isMobile={isMobile} inputStyle={inputStyle}
                    onClose={() => setUprava(false)} onUlozeno={(l) => { onZmena(l); setUprava(false); }} />
            )}
        </div>
    );
}

function UpravaAdresy({ lokace, isDark, isMobile, inputStyle, onClose, onUlozeno }) {
    const [adresa, setAdresa] = useState(lokace?.adresa || '');
    const [nalez, setNalez] = useState(null);   // { lat, lng, static_map_url }
    const [hledam, setHledam] = useState(false);
    const [ukladam, setUkladam] = useState(false);
    const [chyba, setChyba] = useState(null);

    const najdi = async () => {
        setHledam(true); setChyba(null); setNalez(null);
        try { setNalez(await posli('/api/konfigurace/bistro-lokace/geocode', 'POST', { adresa: adresa.trim() })); }
        catch (e) { setChyba(e.message); }
        finally { setHledam(false); }
    };
    const uloz = async () => {
        if (!nalez) { setChyba('Nejdřív adresu najdi na mapě.'); return; }
        setUkladam(true); setChyba(null);
        try {
            await posli('/api/konfigurace/bistro-lokace', 'PUT', { adresa: adresa.trim(), lat: nalez.lat, lng: nalez.lng });
            onUlozeno({ adresa: adresa.trim(), ...nalez });
        } catch (e) { setChyba(e.message); setUkladam(false); }
    };

    return (
        <ModalShell onClose={onClose} isDark={isDark} nadpis="Adresa a poloha" ikona={MapPin} barva={SECTION_COLOR} sirka={560}
            paticka={<PatickaModalu onZrusit={onClose} onPotvrdit={uloz} ukladam={ukladam} potvrdit="Uložit polohu" isDark={isDark} isMobile={isMobile} />}>
            <div style={{ padding: 16 }}>
                <label style={{ display: 'block', fontSize: 11, color: 'var(--text-secondary)', marginBottom: 4 }}>Adresa bistra</label>
                <div className="flex" style={{ gap: 8, flexDirection: isMobile ? 'column' : 'row' }}>
                    <input value={adresa} onChange={(e) => { setAdresa(e.target.value); setNalez(null); }} onKeyDown={(e) => { if (e.key === 'Enter') najdi(); }}
                        placeholder="Ulice a číslo, město" style={{ ...inputStyle, flex: 1 }} autoFocus />
                    <Tlacitko isDark={isDark} Icon={Search} onClick={najdi} disabled={hledam || adresa.trim().length < 3}>{hledam ? 'Hledám…' : 'Najít'}</Tlacitko>
                </div>
                {nalez && (
                    <div style={{ marginTop: 12 }}>
                        <img src={nalez.static_map_url} alt="Nalezená poloha" className="rounded-lg" style={{ width: '100%', border: `1px solid ${cara(isDark)}` }} />
                        <p className="text-xs" style={{ color: tlumene(isDark), margin: '6px 0 0' }}>{Number(nalez.lat).toFixed(6)}, {Number(nalez.lng).toFixed(6)} — sedí špendlík? Pak ulož.</p>
                    </div>
                )}
                {chyba && <p className="text-sm" style={{ color: CERVENA, margin: '8px 0 0' }}>{chyba}</p>}
            </div>
        </ModalShell>
    );
}
